import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const fetcher = () => TablaComunService.getAsSelect(TiposTablaComunConstant.DEPARTAMENTO).then(({ data }) => data)

const DepartamentoSelect = props => {
  const { data: departamentos } = useSwr('select_departamento', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {departamentos.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(DepartamentoSelect)
